import axios from "axios";
import ApiService from "../api.services";

export const UploadService = {
  upload: async function (file, headers) {
    try {
      const response = await axios.post("/api/import/", file, {
        headers: {
          "Content-Type": "multipart/form-data",
          "MaisEnvios-Headers": headers,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  xml: async function (customer, xml) {
    try {
      const response = await ApiService.post("/api/prepost/xml/validate", {
        customer,
        ...xml,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  uploadDocs: async function (formData, endpoint) {
    try {
      const response = await axios.post(`/api/s3upload/${endpoint}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getServiceData: async function (code) {
    try {
      const { data } = await ApiService.get(
        `/api/services/filter/codigo/${code}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
};
